import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from '../data/landing';
const DURATION_MS = 15 * 60 * 1000;
const STORAGE_KEY = 'despertar-offer-deadline';
export function OfferCountdown() {
  const [remaining, setRemaining] = useState(DURATION_MS);
  useEffect(() => {
    let deadline = Number(sessionStorage.getItem(STORAGE_KEY));
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + DURATION_MS;
      sessionStorage.setItem(STORAGE_KEY, String(deadline));
    }
    const tick = () => setRemaining(Math.max(0, deadline - Date.now()));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);
  const totalSeconds = Math.ceil(remaining / 1000);
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return <a href={CHECKOUT_URL} className="flex items-center gap-3 rounded-full border border-gold/50 py-1.5 pl-4 pr-1.5 transition-colors duration-150 hover:border-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-light" aria-label={`La oferta termina en ${minutes} minutos y ${seconds} segundos`} data-id="element-110" data-mp="2wqceo8sxasue">
      <span className="hidden whitespace-nowrap text-xs text-muted sm:inline" data-id="element-111" data-mp="1wqu78ss6jxi0">
        La oferta termina en
      </span>
      <span aria-hidden="true" className="rounded-full bg-gold px-3 py-1 font-display text-sm font-semibold tabular-nums text-ink" data-id="element-112" data-mp="1rrr2zak0xvb3">
        {minutes}:{seconds}
      </span>
    </a>;
}